/*                                                         */
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";

declare global {
  interface Window {
    o_apps: {
      runningInApp: () => boolean;
    };
  }
}

export const isInApp = async (): Promise<boolean> => {
  /*                                                                  */
  await eventQBus.once("apps.global.assets-loaded");

  return window.o_apps.runningInApp();
};
